/**
 * @description VRM Activity Feed route config
 */

(function () {
    'use strict';

    angular.module('vrm.core').config(/* @ngInject */ function ($stateProvider) {
        $stateProvider
            .state('base.admin.users-add', {
                url: '/users/add',
                views: {
                    "body": {
                        template: require('@/angular/views/core/admin/users/form.html'),
                        controller: 'AdminUsersFormController'
                    }
                }
            })
            .state('base.admin.users-update', {
                url: '/users/{id:int}/update',
                views: {
                    "body": {
                        template: require('@/angular/views/core/admin/users/form.html'),
                        controller: 'AdminUsersFormController'
                    }
                }
            })
            .state('base.admin.users-detail', {
                url: '/users/{id:int}/detail',
                views: {
                    "body": {
                        template: require('@/angular/views/core/admin/users/detail.html'),
                        controller: 'AdminUsersDetailController'
                    }
                }
            })
            .state('base.admin.users', {
                url: '/users',
                views: {
                    "body": {
                        template: require('@/angular/views/core/admin/users.html'),
                        controller: 'AdminUsersController'
                    }
                }

            });
    });
})();

